export const styles = {
  pageBackground: {
    backgroundColor: "#fcf9f9",
    backgroundImage:
      "url('https://www.transparenttextures.com/patterns/cream-pixels.png')",
    backgroundRepeat: "repeat",
    minHeight: "100vh",
    color: "#1e0a8f",
    position: "relative",
    margin: "-24px 0", // Container padding alignment fixes
    paddingTop: "20px",
  },
  neonBlob1: {
    position: "absolute",
    width: "450px",
    height: "450px",
    background: "linear-gradient(135deg, #cda6f1, #c1c2fc)",
    top: "-150px",
    left: "-100px",
    filter: "blur(160px)",
    opacity: 0.18,
    pointerEvents: "none",
  },
  neonBlob2: {
    position: "absolute",
    width: "550px",
    height: "550px",
    background: "linear-gradient(135deg, #06b6d4, #ec4899)",
    bottom: "10%",
    right: "-150px",
    filter: "blur(180px)",
    opacity: 0.15,
    pointerEvents: "none",
  },
  mainTitle: { fontSize: "3.5rem", fontWeight: "800", letterSpacing: "-1px" },
  gradientText: {
    background: "linear-gradient(90deg, #06b6d4, #a855f7, #f43f5e)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: { color: "#94a3b8", fontSize: "1.15rem" },
  card: {
    background: "rgba(255, 255, 255, 0.02)",
    backdropFilter: "blur(12px)",
    borderRadius: "24px",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
    overflow: "hidden",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  imageContainer: {
    position: "relative",
    overflow: "hidden",
    paddingBottom: "58%",
  },
  cardImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // objectFit: "cover",
  },
  categoryBadge: {
    position: "absolute",
    bottom: "15px",
    left: "15px",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "0.75rem",
    fontWeight: "700",
  },
  cardBody: {
    padding: "25px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  cardTitle: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#0e1070",
    marginBottom: "12px",
  },
  cardText: { color: "#202020", fontSize: "0.9rem", lineHeight: "1.6" },
  readMoreLink: { fontSize: "0.9rem", fontWeight: "600" },
  backButton: {
    background: "rgba(133, 130, 130, 0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#330c61",
    padding: "8px 20px",
    borderRadius: "30px",
    fontSize: "0.9rem",
    cursor: "pointer",
  },
  articleContainer: {
    background: "rgba(255, 255, 255, 0.01)",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    // backdropFilter: "blur(10px)",
    borderRadius: "32px",
    padding: "30px",
  },
  articleHeaderImageWrapper: {
    position: "relative",
    borderRadius: "20px",
    overflow: "hidden",
    paddingBottom: "50%",
  },
  articleImg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // objectFit: "cover",
  },
  articleBadge: {
    position: "absolute",
    top: "20px",
    left: "20px",
    padding: "8px 16px",
    borderRadius: "30px",
    fontSize: "0.8rem",
    fontWeight: "700",
  },
  articleMainTitle: { fontSize: "2.5rem", fontWeight: "800", color: "#280d8b" },
  articleParagraph: {
    color: "#0a0a0a",
    fontSize: "1.1rem",
    lineHeight: "1.8",
    marginBottom: "20px",
  },
  stickySidebar: {
    position: "sticky",
    top: "30px",
    background: "rgba(255, 255, 255, 0.02)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    backdropFilter: "blur(15px)",
    borderRadius: "28px",
    padding: "25px",
  },
  sidebarSectionHeading: {
    fontSize: "1.25rem",
    fontWeight: "700",
    color: "#838282",
  },
  sidebarAccentLine: {
    width: "50px",
    height: "3px",
    background: "linear-gradient(90deg, #06b6d4, #a855f7)",
    borderRadius: "2px",
    margin: "10px 0 20px 0",
  },
  sidebarItemCard: {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.04)",
    borderRadius: "16px",
    padding: "10px",
    cursor: "pointer",
  },
  sidebarThumb: {
    width: "100%",
    aspectRatio: "1/1",
    objectFit: "cover",
    borderRadius: "12px",
  },
  sidebarItemBody: { paddingLeft: "1px" },
  sidebarItemTitle: {
    fontSize: "0.9rem",
    fontWeight: "400",
    color: "#888787",
    marginTop: "4px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  articleContentHtml: {
    color: "#000205",
    fontSize: "1.1rem",
    lineHeight: "1.8",
    textAlign: "justify",

    "& br": {
      display: "block",
      content: '""',
      marginBottom: "6px", // apne hisab se 4px, 6px, 8px
    },

    "& p": {
      margin: "0 0 10px",
    },

    "& p:empty": {
      display: "none",
    },

    "& ul": {
      paddingLeft: "20px",
      marginTop: "15px",
    },

    "& li": {
      marginBottom: "12px",
      listStyleType: "decimal",
      color: "#e2e8f0",
    },

    "& b": {
      color: "#06b6d4",
      fontWeight: "700",
    },
  },
};
